// Angular
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
	selector: 'kt-search-dropdown',
	templateUrl: './search-dropdown.component.html',
})
export class SearchDropdownComponent implements OnInit {
	// Public properties

	// Set icon class name
	@Input() icon = 'flaticon2-search-1';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	@Input() type: 'brand' | 'success' | 'warning' = 'success';

	@ViewChild('searchInput', {static: true}) searchInput: ElementRef;

	data: any[];
	result: any[];
	loading: boolean;

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	constructor(private cdr: ChangeDetectorRef) {
	}

	/**
	 * On init
	 */
	ngOnInit(): void {
		// simulate result from API
		// type 0|1 as separator or item
		this.result = [
			{
				name: 'Dashboard',
				text: 'Dashboard View',
				permission: 'viewEntityDashboard',
				url: '/entity/dashboard'
			}, {
				name: 'Student',
				text: 'Student List',
				permission: 'viewStudentList',
				url: '/student/studentList'
			}, {
				name: 'Collect Fee',
				text: 'Collect Student Fee ',
				permission: 'collectFee',
				url: '/fee/collectFee'
			}, {
				name: 'Other Income',
				text: 'Collect Other Income',
				permission: 'collectOtherIncome',
				url: '/fee/collectOtherIncomeV2'
			}, {
				name: 'Fee Reports',
				text: 'View Fee Reports',
				permission: 'viewFeeReports',
				url: '/fee/feeReports'
			}, {
				name: 'Daily Fee Report',
				text: 'view Daily Fee Report',
				permission: 'viewDailyFeeReport',
				url: '/fee/dailyFeeReport'
			}, {
				name: 'Due Fee Report',
				text: 'view Due Fee Report',
				permission: 'viewDueFeeReport',
				url: '/fee/dueFeeReport'
			}, {
				name: 'Concession Report',
				text: 'View Concession Report',
				permission: 'viewConcessionReport',
				url: '/fee/concessionReport'
			}, {
				name: 'Daily FeeHead Collection Report',
				text: 'View',
				permission: 'viewDailyFeeHeadCollectionReport',
				url: '/fee/dailyFeeHeadCollectionReport'
			}, {
				name: 'Course Wise Collection Report',
				text: 'View Course Wise Collection Report',
				permission: 'viewCourseWiseCollectionReport',
				url: '/fee/courseWiseReport'
			}, {
				name: 'Combined Daily Collection Report',
				text: 'View Combined Daily Collection Report',
				permission: 'viewCombinedDailyCollectionReport',
				url: '/fee/combinedDailyCollectionReport'
			}, {
				name: 'Transaction List',
				text: 'View All Transaction List',
				permission: 'viewTransactionList',
				url: '/fee/transactionList'
			}, {
				name: 'Users',
				text: 'View Users',
				permission: 'viewUserList',
				url: '/users'
			}, {
				name: 'Attendance',
				text: 'View Student Attendance',
				permission: 'viewStudentAttendanceList',
				url: '/attendance/studentAttendance'
			}, {
				name: 'Employee',
				text: 'View Employee',
				permission: 'viewEmployeeList',
				url: '/hrm/employee'
			}, {
				name: 'Marks Entry',
				text: 'View Marks Entry',
				permission: 'viewAssessmentMarks',
				url: '/examination/assessmentsMarks'
			}, {
				name: 'Assessment Wise Report',
				text: 'View Assessment Wise Report',
				permission: 'viewMarksByCourse',
				url: '/examination/assessmentsWiseReport'
			}, {
				name: 'Green Sheet',
				text: 'View Green Sheet',
				permission: 'viewGreenSheet',
				url: '/examination/greenSheet'
			}, {
				name: 'Resource Preson',
				text: 'View Resource Preson',
				permission: 'viewResourcePersonList',
				url: '/advancedSetup/resourcePerson'
			}, {
				name: 'Dashboard',
				text: 'View ',
				permission: 'viewEntityDashboard',
				url: '/entity'
			},
		];
	}

	/**
	 * Search
	 * @param e: Event
	 */
	search(e) {
		this.data = null;
		if (e.target.value.length > 2) {
			this.loading = true;
			// simulate getting search result
			setTimeout(() => {
				this.data = this.result.filter(s=>{
				return	(s.text.toLowerCase()).includes(e.target.value.toLowerCase())
				})
				// this.data = this.result;
				this.loading = false;
				this.cdr.markForCheck();
			}, 500);
		}
	}

	/**
	 * Clear search
	 *
	 * @param e: Event
	 */
	clear(e) {
		this.data = null;
		this.searchInput.nativeElement.value = '';
	}

	openChange() {
		setTimeout(() => this.searchInput.nativeElement.focus());
	}
}
